<!--
/**
  退款管理列表 
*/
-->
<template>
  <scroll-layout>
    <template #header>
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @click="handleSearchConfirm"
        @clean="handleSearchClean"></ykc-search>
    </template>
    <div class="motorcade-main-account">
      <ykc-table
        ref="YkcTable"
        :data="tableData"
        :columns="tableColumns"
        title="退款列表"
        operateFixedType="right"
        :operateButtons="tableOperateButtons.filter(item => item.enabled())">
        <!-- <template #headerButtons>
          <ykc-button
            v-for="(button, index) in pageButtons.filter(item => item.enabled())"
            :key="button.id || index"
            v-bind="button"
            @click="handlePageButtonClick(button, $event)">
            {{ button.text }}
          </ykc-button>
        </template> -->
        <ykc-pagination
          slot="pagination"
          ref="YkcPagination"
          direct="flex-end"
          :total="pageInfo.total"
          :page-size.sync="pageInfo.pageSize"
          :current-page.sync="pageInfo.pageIndex"
          @size-change="handlePaginationSizeChange"
          @current-change="handlePaginationCurrentChange"></ykc-pagination>
      </ykc-table>
    </div>
  </scroll-layout>
</template>

<script>
  import { code } from '@/utils';
  import YkcDialog from '@/components/ykc-ui/dialog';
  import { cSideDriverAccount, investmentData } from '@/service/apis';

  export default {
    name: 'CSideDriverAccountsList',

    data() {
      return {
        id: '',
        dictionary: {},
        polymerizationInfo: {},
        pageButtons: [],
        tableData: [],

        tableColumns: [
          { label: '订单编号', prop: 'tradeSeq', width: '240px', fixed: true },
          { label: '充电用户', prop: 'userAccount', minWidth: '200px' },
          { label: '终端编码', prop: 'gunCode', minWidth: '200px' },
          { label: '商户号名称', prop: 'machName', minWidth: '200px' },
          { label: '商户订单号', prop: 'payRespNo', minWidth: '260px' },
          { label: '退款类型', prop: 'refundTypeName', minWidth: '100px' },
          { label: '退款原因', prop: 'reason', minWidth: '100px' },
          { label: '退款金额', prop: 'refundAmt', minWidth: '100px' },
          { label: '申请人', prop: 'createdNo', minWidth: '100px' },
          { label: '申请时间', prop: 'createdTime', minWidth: '200px' },
          { label: '操作员', prop: 'modifiedNo', minWidth: '00px' },
          { label: '财务审核时间', prop: 'modifiedTime', minWidth: '200px' },
          {
            label: '退款状态',
            prop: 'status',
            minWidth: '100px',
            scopedSlots: {
              default: ({ row }) => {
                const statusName = this.statusData.filter(item => item.id === row.status)[0].name;
                return <span>{statusName}</span>;
              },
            },
          },
          { label: '退款失败原因', prop: 'failReason', minWidth: '200px' },
          { label: '备注', prop: 'remark', minWidth: '200px' },
        ],

        tableOperateButtons: [
          {
            enabled: () => code('finance:account:refund:pass'),
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                disabled={row.status !== 1}
                onClick={() => {
                  this.refundStatus(row, 1);
                }}>
                通过
              </ykc-button>
            ),
          },
          {
            enabled: () => code('finance:account:refund:refuse'),
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                disabled={row.status !== 1 || row.refundType === 2 || row.refundType === 3}
                onClick={() => {
                  this.refundStatus(row, 2);
                }}>
                拒绝
              </ykc-button>
            ),
          },
          {
            enabled: () => code('finance:account:refund:detail'),
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                onClick={() => {
                  this.$router.push({
                    path: '/financialManagement/accountManagement/refundDetail',
                    query: { id: row.id },
                  });
                }}>
                详情
              </ykc-button>
            ),
          },
        ],
        pageInfo: {
          total: 0,
          pageIndex: 1,
          pageSize: 10,
        },
        searchParams: {
          tradeSeq: '',
          gunCode: '',
          userAccount: '',
          payRespNo: '',
          machCode: '',
          status: '',
          refundType: '',
          timeStart: '',
          timeEnd: '',
        },
        mchData: [],
        refundTypeData: [
          { id: 1, name: '订单退款' },
          { id: 2, name: '活动退款' },
          { id: 3, name: '超期退款' },
          { id: 4, name: '售卖卡券订单退款' },
        ],
        statusData: [
          { id: 1, name: '退款中' },
          { id: 2, name: '已退款' },
          { id: 3, name: '已拒绝' },
        ],
      };
    },
    created() {
      this.searchTableList();
      this.requestAllMch();
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcDatePicker',
            key: 'operationTime',
            label: '申请时间',
            placeholder: '请选择申请时间',
          },
          {
            comName: 'YkcInput',
            key: 'tradeSeq',
            label: '充电单号',
            placeholder: '请输入充电单号',
          },
          {
            comName: 'YkcInput',
            key: 'gunCode',
            label: '终端编码',
            placeholder: '请输入终端编码',
          },
          {
            comName: 'YkcInput',
            key: 'userAccount',
            label: '充电用户',
            placeholder: '请输入充电用户',
          },
          {
            comName: 'YkcDropdown',
            key: 'status',
            label: '退款状态',
            placeholder: '请选择退款状态',
            data: this.statusData,
          },
          {
            comName: 'YkcInput',
            key: 'payRespNo',
            label: '商户订单号',
            placeholder: '请输入商户订单号',
          },
          {
            comName: 'YkcDropdown',
            key: 'machCode',
            label: '商户号名称',
            placeholder: '请选择商户号名称',
            data: this.mchData,
          },
          {
            comName: 'YkcDropdown',
            key: 'refundType',
            label: '退款类型',
            placeholder: '请选择退款类型',
            data: this.refundTypeData,
          },
        ];
      },
    },
    methods: {
      changeStateSearch() {
        this.pageInfo.pageIndex = 1;
        this.searchTableList();
      },
      /**
       * 获取商户信息
       */
      requestAllMch() {
        investmentData
          .wxMch({})
          .then(res => {
            this.mchData =
              res?.map(item => ({
                id: item.code,
                name: item.name,
              })) || [];
          })
          .catch(err => {
            console.log(err);
          });
      },
      /** 退款审核 */
      refundStatus(row, type) {
        const txt = type === 1 ? '通过' : '拒绝';
        YkcDialog({
          showTitle: false,
          showFooter: true,
          dialogType: 'feedback',
          desc: `是否确定${txt}该退款？`,
          onCancel: dialogDone => {
            dialogDone(); // 隐藏弹窗
          },
          onConfirm: dialogDone => {
            cSideDriverAccount.auditApplyRefund({ id: row.id, type }).then(res => {
              dialogDone(); // 隐藏弹窗
              this.searchTableList();
            });
          },
        });
      },
      /** 根据条件查询数据 */
      searchTableList() {
        const params = {
          ...this.searchParams,
          current: this.pageInfo.pageIndex,
          size: this.pageInfo.pageSize,
        };
        cSideDriverAccount.refundList(params).then(res => {
          console.log(res);
          this.tableData = res?.records || [];
          this.pageInfo.total = res?.total || 0;
        });
      },

      /**
       * @desc 点击页面左上角按钮 callback
       * */
      handlePageButtonClick(button, event) {
        if (typeof button.handleClick === 'function') {
          button.handleClick(button, event);
        }
      },
      /**
       * @desc 点击查询按钮
       * */
      handleSearchConfirm(form) {
        this.pageInfo.pageIndex = 1;
        Object.assign(this.searchParams, form);
        if (form.operationTime && form.operationTime.length > 0) {
          [this.searchParams.timeStart, this.searchParams.timeEnd] = form.operationTime;
        }
        this.searchTableList();
      },
      /**
       * 点击清空查询按钮
       * */
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
      },
      /**
       * @desc 分页 change 事件监听器
       * */
      handlePaginationCurrentChange(current) {
        this.pageInfo.pageIndex = current;
        this.searchTableList();
      },
      /**
       * 分页 size  change  事件监听器
       * */
      handlePaginationSizeChange(size) {
        this.pageInfo.pageIndex = 1;
        this.pageInfo.pageSize = size;
        this.searchTableList();
      },
      /**
       * 重置 form data
       * */
      resetFormData() {
        this.ruleForm = {};
      },
    },
  };
</script>
<style lang="scss" scoped>
  .drawer-button-wrap {
    padding: 0 10px;
    button {
      margin-right: 5px;
    }
  }
  .link {
    color: blue;
    cursor: pointer;
  }
  .el-radio-group .item {
    border: 0;
  }
</style>
